import {useEffect} from 'react';
import ReactModal from 'react-modal';
import {Typography} from '~library/atoms/Typography';
import {Button} from '~library/atoms/Button';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import './MediaUploadModal.sass';

type ModalProps = {
  ctaButtonText: string;
  description: string;
  header: string;
  hideModal: () => void;
  appElement: string;
};

export const MediaUploadModal = ({
  hideModal,
  header,
  description,
  ctaButtonText,
  appElement,
}: ModalProps) => {
  useEffect(() => {
    ReactModal.setAppElement(appElement);
  }, [appElement]);
  return (
    <ReactModal
      isOpen
      className="media-upload-modal"
      overlayClassName="media-upload-modal--overlay"
    >
      <div className="media-upload-modal--header">
        <div className="media-upload-modal--header-container">
          <AlertLineIcon ratio={0.75} color="red" />
          <Typography variant="header5" classNames="media-upload-modal--header--text">
            Error: {header}
          </Typography>
        </div>
        <Button
          variant="transparent"
          icon={<CloseLineIcon ratio={0.75} color="black" />}
          onClick={hideModal}
        />
      </div>
      <Typography variant="paragraph2" classNames="media-upload-modal--description">
        {description}
      </Typography>
      <Button className="media-upload-modal--cta" onClick={hideModal}>
        {ctaButtonText}
      </Button>
    </ReactModal>
  );
};
